import { c as _c } from "react/compiler-runtime";
import { INITIAL_AVAILABILITY_FILTERS } from '@winelidays/wld-tsx-2/constants';
import { useDateFormStepCreator, useLanguageFormStepCreator, usePersonsFormStepCreator } from '@winelidays/wld-tsx-2/hooks';
import { reconcileLocalFilters, storeLocalFilters } from './availabilitiyFilters.localStorage';
import AvailabilityFiltersContext from './availabilityFilters.context';
export const AvailabilityFiltersProvider = t0 => {
    const $ = _c(30);
    const { children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = reconcileLocalFilters(INITIAL_AVAILABILITY_FILTERS);
        $[0] = t1;
    }
    else {
        t1 = $[0];
    }
    const reconciledFilters = t1;
    const t2 = useDateFormStepCreator(reconciledFilters.date);
    let date;
    let dateFormStepResult;
    if ($[1] !== t2) {
        ({
            dateFormStep: date,
            ...dateFormStepResult
        } = t2);
        $[1] = t2;
        $[2] = date;
        $[3] = dateFormStepResult;
    }
    else {
        date = $[2];
        dateFormStepResult = $[3];
    }
    const { resetDateFormStep } = dateFormStepResult;
    const t3 = usePersonsFormStepCreator(reconciledFilters.persons);
    let persons;
    let personsFormStepResult;
    if ($[4] !== t3) {
        ({
            personsFormStep: persons,
            ...personsFormStepResult
        } = t3);
        $[4] = t3;
        $[5] = persons;
        $[6] = personsFormStepResult;
    }
    else {
        persons = $[5];
        personsFormStepResult = $[6];
    }
    const { resetPersonsFormStep } = personsFormStepResult;
    const t4 = useLanguageFormStepCreator(reconciledFilters.language);
    let language;
    let languageFormStepResult;
    if ($[7] !== t4) {
        ({
            languageFormStep: language,
            ...languageFormStepResult
        } = t4);
        $[7] = t4;
        $[8] = language;
        $[9] = languageFormStepResult;
    }
    else {
        language = $[8];
        languageFormStepResult = $[9];
    }
    const { resetLanguageFormStep } = languageFormStepResult;
    let t5;
    if ($[10] !== resetDateFormStep || $[11] !== resetLanguageFormStep || $[12] !== resetPersonsFormStep) {
        t5 = t6 => {
            const initialValue = t6 === undefined ? INITIAL_AVAILABILITY_FILTERS : t6;
            resetDateFormStep(initialValue.date);
            resetPersonsFormStep(initialValue.persons);
            resetLanguageFormStep(initialValue.language);
        };
        $[10] = resetDateFormStep;
        $[11] = resetLanguageFormStep;
        $[12] = resetPersonsFormStep;
        $[13] = t5;
    }
    else {
        t5 = $[13];
    }
    const handleResetFilters = t5;
    let t6;
    if ($[14] !== date || $[15] !== language || $[16] !== persons) {
        t6 = {
            persons,
            language,
            date
        };
        $[14] = date;
        $[15] = language;
        $[16] = persons;
        $[17] = t6;
    }
    else {
        t6 = $[17];
    }
    const filters = t6;
    let t7;
    if ($[18] !== filters) {
        t7 = () => {
            storeLocalFilters(filters);
        };
        $[18] = filters;
        $[19] = t7;
    }
    else {
        t7 = $[19];
    }
    const handleSaveFilters = t7;
    let t8;
    if ($[20] !== dateFormStepResult || $[21] !== filters || $[22] !== handleResetFilters || $[23] !== handleSaveFilters || $[24] !== languageFormStepResult || $[25] !== personsFormStepResult) {
        t8 = {
            ...dateFormStepResult,
            ...personsFormStepResult,
            ...languageFormStepResult,
            filters,
            handleResetFilters,
            handleSaveFilters
        };
        $[20] = dateFormStepResult;
        $[21] = filters;
        $[22] = handleResetFilters;
        $[23] = handleSaveFilters;
        $[24] = languageFormStepResult;
        $[25] = personsFormStepResult;
        $[26] = t8;
    }
    else {
        t8 = $[26];
    }
    const contextValue = t8;
    let t9;
    if ($[27] !== children || $[28] !== contextValue) {
        t9 = <AvailabilityFiltersContext value={contextValue}>{children}</AvailabilityFiltersContext>;
        $[27] = children;
        $[28] = contextValue;
        $[29] = t9;
    }
    else {
        t9 = $[29];
    }
    return t9;
};
